import {validatorSettings} from "../../../../../../utils/validators/validatorSettings";
import StringValidator from "../../../../../../utils/validators/StringValidator";
import DateTimeValidator from "../../../../../../utils/validators/DateTimeValidator";
import PhoneValidator from "../../../../../../utils/validators/PhoneValidator";
import {Translation} from "../../../../../../../language/translation/translations";
import AppUserRequest from "../../../../../../service/appUser/AppUserRequest";


export default class BookingPersonFormValidator {
  translation: Translation;
  appUserRequest: AppUserRequest;
  nameValidator: StringValidator;
  surnameValidator: StringValidator;
  bornValidator: DateTimeValidator;
  phoneValidator: PhoneValidator;

  constructor(translation: Translation, appUserRequest: AppUserRequest) {
    this.translation = translation;
    this.appUserRequest = appUserRequest;
    this.nameValidator = new StringValidator(translation, validatorSettings.nameMaxChars, true);
    this.surnameValidator = new StringValidator(translation, validatorSettings.surnameMaxChars, true, true);
    this.bornValidator = new DateTimeValidator(translation);
    this.phoneValidator = new PhoneValidator(translation);
  }

  validateForm = () => {
    this.nameValidator.validate(this.appUserRequest.name);
    this.surnameValidator.validate(this.appUserRequest.surname);
    this.phoneValidator.validate(this.appUserRequest.phone)
    this.bornValidator.validate(this.appUserRequest.born);

    return (
      this.nameValidator.isValid &&
      this.surnameValidator.isValid &&
      this.bornValidator.isValid &&
      this.phoneValidator.isValid
    )
  }
}